import { ENUM_UnsubscribeCodeType } from '@api-new/common';

export const ENUM_UnsubscribeCodeTypeMap = new Map([
  [ENUM_UnsubscribeCodeType.UNSUBSCRIBE_CODE_TYPE_BETTER_DEAL_ALERT, 'Better Deal Alert'],
  [ENUM_UnsubscribeCodeType.UNSUBSCRIBE_CODE_TYPE_HOME_REPORT, 'Home Report'],
  [ENUM_UnsubscribeCodeType.UNSUBSCRIBE_CODE_TYPE_MORTGAGE_UPDATE, 'Mortgage Update'],
]);
